import React, { createRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import EditText from '../../component/EditText';
import SelectBox from '../../component/SelectBox';
import EditTextArea from '../../component/EditTextArea';
import SelectDate from '../../component/CalendarField';
import SelectFile from '../../component/SelectFileOld';
import MyButton from '../../component/Button';
import moment from 'moment';
import HookRoute from '../../HookRoute';

import { Get, Update, Create, Delete } from './http';

class FormsElements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                id: 0,
                title: '',
                content: '',
                files: '',
                openedAt: moment().format('YYYY-MM-DD'),
                closedAt: moment().format('YYYY-MM-DD'),
                status: 'OPENED',
            },
            type: [
                { idx: 'NORMAL', title: '일반' },
                { idx: 'FIX', title: '고정' },
            ],
        };

        // if (this.id) {
        //     Get(this, this.id, this.resultGet.bind(this));
        // }
    }

    // componentDidMount() {}

    /**
     * 정보
     */
    resultGet = response => {
        this.setState({
            data: response,
        });
    };

    /**
     * 저장
     * @param e
     */
    clickSave = e => {
        const { data } = this.state;

        if (this.id) {
            Update(this, this.id, data, this.resultSave);
        } else {
            Create(this, data, this.resultSave);
        }
    };

    /**
     * 저장하기
     */
    resultSave = res => {
        alert('저장이 완료 되었습니다.');
        window.location = '/a/notice/list';
    };

    /**
     * 삭제
     * @param  e
     */
    clickDelete = e => {
        var result = window.confirm('삭제 하시겠습니까?');
        if (result) {
            Delete(this, this.id, this.resultDelete);
        } else {
        }
    };

    /**
     * 삭제하기
     */
    resultDelete = res => {
        alert('삭제가 완료 되었습니다.');
        window.location = '/a/notice/list';
    };

    render() {
        const { data } = this.state;

        return (
            <HookRoute
                load={params => {
                    const { id } = params;
                    this.id = id;
                    if (this.id) {
                        Get(this, this.id, this.resultGet.bind(this));
                    }
                }}
            >
                <Row>
                    <Col>
                        <Card className="white">
                            <Card.Header>
                                <Card.Title as="h5">{this.id ? '공지사항 정보' : '공지사항 등록'}</Card.Title>
                            </Card.Header>

                            <Card.Body>
                                <div className="sort_input">
                                    <SelectBox
                                        title="구분"
                                        value={data.type}
                                        items={this.state.type}
                                        show_key={'idx'}
                                        show_val={'title'}
                                        parent={this}
                                        name={'type'}
                                        onChange={e => {
                                            data.type = e.target.value;
                                            this.setState(data);
                                        }}
                                    />
                                    <SelectDate
                                        title="게시일"
                                        value={moment(data.openedAt).format('YYYY-MM-DD')}
                                        parent={this}
                                        onChange={date => {
                                            data.openedAt = moment(date).format('YYYY-MM-DD');
                                            this.setState(data);
                                        }}
                                    />

                                    {data.type === 'FIX' && (
                                        <SelectDate
                                            title="종료일"
                                            value={data.closedAt ? moment(data.closedAt).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
                                            parent={this}
                                            onChange={date => {
                                                data.closedAt = moment(date).format('YYYY-MM-DD');
                                                this.setState(data);
                                            }}
                                        />
                                    )}
                                    {/* <SelectBox
                                        show_sub_title={true}
                                        title={'구분'}
                                        items={this.props.parent.state.status}
                                        show_key={'idx'}
                                        show_val={'title'}
                                        parent={this.props.parent}
                                        name={'data/status'}
                                        value={data.status}
                                    /> */}

                                    <EditText
                                        title={'제목'}
                                        value={data.title}
                                        placeholder="제목을 입력하세요."
                                        onChange={e => {
                                            data.title = e.target.value;
                                            this.setState(data);
                                        }}
                                    />

                                    <EditTextArea
                                        title={'내용'}
                                        value={data.content}
                                        placeholder="내용을 입력하세요."
                                        onChange={e => {
                                            data.content = e.target.value;
                                            this.setState(data);
                                        }}
                                    />

                                    <SelectFile
                                        title={'파일첨부'}
                                        value={data.files}
                                        onChange={file => {
                                            data.files = file;
                                            this.setState(data);
                                        }}
                                    />
                                </div>
                            </Card.Body>
                        </Card>

                        <div className="voting_fixed_bottom">
                            <MyButton
                                title={'목록'}
                                variant="primary"
                                onClick={e => {
                                    window.location = '/a/notice/list';
                                }}
                            />
                            {this.id && <MyButton title={'삭제'} variant="danger" onClick={this.clickDelete} />}
                            <MyButton title={!this.id ? '등록' : '저장'} variant="primary" onClick={this.clickSave} />
                        </div>
                    </Col>
                </Row>
            </HookRoute>
        );
    }
}

export default FormsElements;
